import React, { useState, useMemo } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { useTranslation } from 'react-i18next';

import { useSettingsContext } from '../../../setting/SettingsContext';
import { defaultSettings } from '../../../setting/config-setting';
import SettingsDrawer from './SettingsDrawer';

// Compare current settings against defaults — used to surface a small
// red dot on the gear icon whenever the user has any non-default
// preference active. Mirrors the minimal-dashboard pattern.
//
// NOTE: themeDirection is intentionally excluded — it's driven by the
// navbar language toggle (TransLang), so a non-default direction
// follows automatically from picking Arabic and shouldn't surface as
// a settings override.
const KEYS_TO_COMPARE = [
    'themeMode',
    'themeColorPresets',
    'themeFontFamily',
    'themeStretch',
    'themeNavColor',
    'themeLayout',
];

const SettingsButton = () => {
    const { t } = useTranslation();
    const settings = useSettingsContext();
    const [open, setOpen] = useState(false);

    const hasOverrides = useMemo(
        () => KEYS_TO_COMPARE.some((k) => settings[k] !== defaultSettings[k]),
        [settings]
    );

    return (
        <>
            <Tooltip title={t('Settings', { defaultValue: 'Settings' })} arrow>
                <IconButton
                    aria-label="Open settings"
                    onClick={() => setOpen(true)}
                    sx={{
                        color: '#FFFFFF',
                        '&:hover': { bgcolor: 'rgba(15,23,42,0.12)' },
                    }}
                >
                    <Badge
                        color="error"
                        variant="dot"
                        invisible={!hasOverrides}
                        overlap="circular"
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <SettingsRoundedIcon />
                    </Badge>
                </IconButton>
            </Tooltip>

            <SettingsDrawer open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default SettingsButton;
